export const exportParams = {
  columnKeys: [
    'app_key',
    'app_version',
    'content',
    'content_en',
    'country_code',
    'language',
    'created_at',
    'device',
    'last_answer_date',
    'last_answer_content',
    'ml_labels',
    'ram_mb',
    'rating',
    'sdk_version',
    'status',
    'title',
    'title_en',
    'topics_for_export',
    'username',
  ],
  onlySelected: true,
}
